const API_URL = "https://dev.dimalink.cl/api/Modulos";

/**
 * Crear un módulo
 */
export async function crearModulo(modulo) {
  try {
    const response = await fetch(`${API_URL}/crear`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(modulo),
    });
    if (!response.ok) throw new Error(await response.text());
    return await response.json();
  } catch (error) {
    console.error("❌ Error al crear módulo:", error);
    throw error;
  }
}

/**
 * Actualizar un módulo
 * @param {Object} modulo - Objeto con TODAS las propiedades requeridas, incluyendo moduloId
 */
export async function actualizarModulo(modulo) {
  try {
    const response = await fetch(`${API_URL}/modificar`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        moduloId: modulo.moduloId, // obligatorio para identificar
        campoId: modulo.campoId,
        moduloNombre: modulo.moduloNombre,
        codigoUnicoHash: modulo.codigoUnicoHash,
        categoriaId: modulo.categoriaId,
        estadoId: modulo.estadoId,
        ip: modulo.ip,
        vigencia: modulo.vigencia,
        usuarioId: modulo.usuarioId,
      }),
    });
    if (!response.ok) throw new Error(await response.text());
    return await response.json();
  } catch (error) {
    console.error("❌ Error al actualizar módulo:", error);
    throw error;
  }
}

/**
 * Eliminar un módulo
 */
export async function eliminarModulo(modulo) {
  try {
    const response = await fetch(`${API_URL}/eliminar`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(modulo),
    });
    if (!response.ok) throw new Error(await response.text());
    return await response.json();
  } catch (error) {
    console.error("❌ Error al eliminar módulo:", error);
    throw error;
  }
}
